// extracted by mini-css-extract-plugin
export default {"valuesText":"RequestStatisticBlock_valuesText__Y3huq","value":"RequestStatisticBlock_value__AbmAD"};